import { __read, __spread } from "tslib";
import { formatValue as valueFormatter, } from '@keen.io/charts-utils';
import { KEEN_KEY, KEEN_TABLE_INTERVAL } from '@keen.io/parser';
import { VALUE } from '../../constants';
export var chronologicalTransformation = function (data, keys, formatValue) {
    var columns = [KEEN_TABLE_INTERVAL, VALUE];
    var rows = [];
    data.forEach(function (item) {
        rows.push.apply(rows, __spread(keys.map(function (keyName) { return [
            item[KEEN_KEY],
            valueFormatter(item[keyName], formatValue),
        ]; })));
    });
    return __spread([columns], rows);
};
